import React from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';
import { GuestRoute } from './components/GuestRoute';
import { ProtectedRoute } from './components/ProtectedRoute';
import { FeatureGate } from './components/FeatureGate';
import { ProtectedAppShell } from './components/layout/ProtectedAppShell';
import AlertsPage from './pages/AlertsPage';
import AssetsPage from './pages/AssetsPage';
import ApproveCancelDeletionPage from './pages/ApproveCancelDeletionPage';
import ConfirmEmailPage from './pages/ConfirmEmailPage';
import DashboardPage from './pages/DashboardPage';
import DownloadPage from './pages/DownloadPage';
import ForgotPasswordPage from './pages/ForgotPasswordPage';
import LandingPage from './pages/LandingPage';
import LoginPage from './pages/LoginPage';
import MomoPage from './pages/MomoPage';
import MarketplacePage from './pages/MarketplacePage';
import CheckoutPage from './pages/CheckoutPage';
import NetworkPage from './pages/NetworkPage';
import PricingPage from './pages/PricingPage';
import ReportDetailPage from './pages/ReportDetailPage';
import ReportsPage from './pages/ReportsPage';
import ResetPasswordPage from './pages/ResetPasswordPage';
import SettingsPage from './pages/SettingsPage';
import SignupPage from './pages/SignupPage';
import SupportAccessPage from './pages/SupportAccessPage';

function App() {
  return (
    <Routes>
      <Route path="/" element={<LandingPage />} />
      <Route path="/approve-cancel-deletion" element={<ApproveCancelDeletionPage />} />
      <Route path="/confirm-email" element={<ConfirmEmailPage />} />
      <Route path="/pricing" element={<PricingPage />} />
      <Route
        path="/login"
        element={
          <GuestRoute>
            <LoginPage />
          </GuestRoute>
        }
      />
      <Route
        path="/signup"
        element={
          <GuestRoute>
            <SignupPage />
          </GuestRoute>
        }
      />
      <Route
        path="/forgot-password"
        element={
          <GuestRoute>
            <ForgotPasswordPage />
          </GuestRoute>
        }
      />
      <Route path="/reset-password" element={<ResetPasswordPage />} />
      <Route
        element={
          <ProtectedRoute>
            <ProtectedAppShell />
          </ProtectedRoute>
        }
      >
        <Route path="/dashboard" element={<DashboardPage />} />
        <Route path="/alerts" element={<AlertsPage />} />
        <Route path="/assets" element={<AssetsPage />} />
        <Route
          path="/download"
          element={
            <ProtectedRoute>
              <DownloadPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/momo"
          element={
            <FeatureGate feature="momoProtection" fallback={<Navigate to="/dashboard" replace />}>
              <MomoPage />
            </FeatureGate>
          }
        />
        <Route path="/network" element={<NetworkPage />} />
        <Route
          path="/marketplace"
          element={
            <ProtectedRoute>
              <MarketplacePage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/checkout"
          element={
            <ProtectedRoute>
              <CheckoutPage />
            </ProtectedRoute>
          }
        />
        <Route path="/reports/april-2026" element={<ReportDetailPage />} />
        <Route path="/reports" element={<ReportsPage />} />
        <Route path="/settings" element={<SettingsPage />} />
        <Route path="/settings/support-access" element={<SupportAccessPage />} />
      </Route>
    </Routes>
  );
}

export default App;
